export function displayCookieBanner() {
  const cookieBanner = document.querySelector('.cookie-notice-container');
  const cookieBannerAcceptButton = cookieBanner.querySelector('[data-toggle="accept"]');

  if (!localStorage.getItem('cookies')) {
    cookieBanner.classList.add('active');
    cookieBannerAcceptButton && cookieBannerAcceptButton.addEventListener('pointerup',  () => {
      cookieBanner.classList.remove('active');
      localStorage.setItem('cookies', 'accepted');
    });
  }
}
